import { Box, Button, CircularProgress, OutlinedInput, Typography, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { Cobertura } from '../../../interfaces/entities/ConsultarCoberturas/Cobertura';
import { getCoberturasContratuais } from '../../../services/ContratoService';
import CoverageDataCard from './CoverageDataCard';
import './styles.css';
import { sxButton, sxCircularLoadingProgressCoverage, sxFindCoverageByTussBox, sxInput, sxLabel, sxLabeledOutlinedInput, sxSubtitle, sxTitle } from './sxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import PageTitle from '../../../components/Accessibility/PageTitle';

const ConsultarCoberturas: React.FC = () => {

  const mobileScreen = useMediaQuery('(max-width: 768px)');
  const [loading, setLoading] = useState<boolean>(false);
  const [codTuss, setCodTuss] = useState<string>();
  const [cobertura, setCobertura] = useState<Cobertura>();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const accessibility = useAccessibility();

  const getCoverage = async (pCodProced: string) => {
    setCobertura(undefined);
    setLoading(true);
    const response = await getCoberturasContratuais(pCodProced);
    if (response?.status === 200) {
      const coverageData = response.data;
      setCobertura(coverageData);
    } else {
      console.error(response);
      openModalError('Erro ao consultar coberturas', 'Ocorreu um erro ao consultar as coberturas. Tente novamente em instantes.');
    }
    setLoading(false);
  }

  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Fechar',
      showButtonModal: true,
      closeAction: () => setModalFeedback(null),
      buttonAction: () => setModalFeedback(null)
    });
  }

  const handlePressEnter = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      getCoverage(codTuss || '');
    }
  };

  return (
    <>
      <div className='coverage-container'>
        <PageTitle text="Consultar coberturas" />
        <Typography sx={sxSubtitle} style={accessibility.textStyleAccessibility}>
          Aqui você consegue consultar a cobertura contratual de procedimentos e exames. Para isso, é necessário informar o Código da Tabela TUSS
          (Terminologia Unificada da Saúde Suplementar), com oito números, fornecido pelo seu médico ou prestador de serviços. Ao buscar o código,
          fique atento à informação sobre o cumprimento de carências ou de cobertura parcial temporária.
        </Typography>
        <Box sx={sxFindCoverageByTussBox}>
          <Box sx={sxLabeledOutlinedInput}>
            <Typography style={accessibility.textStyleAccessibility} sx={sxLabel}>Código do procedimento</Typography>
            <label htmlFor='codigoProcedimentoInput' aria-label='Código do procedimento' />
            <OutlinedInput
              id="codigoProcedimentoInput"
              fullWidth={mobileScreen}
              type={'text'}
              value={codTuss}
              placeholder='99999999'
              onKeyDown={handlePressEnter}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '');
                setCodTuss(value.toUpperCase());
              }}
              name='numero'
              inputProps={{ maxLength: 8 }}
              maxRows={1}
              style={accessibility.textStyleAccessibility}
              sx={sxInput}
            />
          </Box>
          <Button
            variant="contained"
            size="large"
            onClick={() => getCoverage(codTuss || '')}
            type="button"
            disabled={!codTuss}
            sx={sxButton}
            style={accessibility.buttonStyleAccessibility}
            fullWidth={mobileScreen}
          >
            <Typography style={accessibility.buttonTextStyleAccessibility}>CONSULTAR</Typography>
          </Button>
        </Box>
        {loading ? <CircularProgress sx={sxCircularLoadingProgressCoverage} /> :
          <>
            {!!cobertura?.lstResultado.length ?
              <CoverageDataCard cobertura={cobertura} />
              :
              <>
                {!!cobertura?.descrProced && <Typography>{cobertura.descrProced}</Typography>}
              </>
            }
          </>
        }

      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default ConsultarCoberturas;